import PlaceBidForm from './PlaceBidForm';

export default PlaceBidForm;
